import { AppHubCard } from "@/components/common/AppHubCard";
import { AppHubPage } from "@/components/common/AppHubPage";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";
import { Flag, Smile, Sparkles } from "lucide-react";

const iconGalleryItems = [
    {
        title: "Animations",
        description: "Lottie navigation and UI icons. Hover to preview playback.",
        icon: <Sparkles className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-fuchsia-500 to-fuchsia-600",
        bgGradient: "bg-gradient-to-br from-fuchsia-50 to-fuchsia-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-fuchsia-100/50 before:to-fuchsia-200/50",
        borderColor: "border-fuchsia-200 hover:border-fuchsia-300",
        primaryButtonClassName: "bg-fuchsia-600 hover:bg-fuchsia-700",
        links: [{ to: "/design/icons/animations", label: "Animation icons" }],
    },
    {
        title: "States",
        description: "Diary status, flags, and workflow state illustrations.",
        icon: <Flag className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-sky-500 to-sky-600",
        bgGradient: "bg-gradient-to-br from-sky-50 to-sky-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-sky-100/50 before:to-sky-200/50",
        borderColor: "border-sky-200 hover:border-sky-300",
        primaryButtonClassName: "bg-sky-600 hover:bg-sky-700",
        links: [{ to: "/design/icons/states", label: "State icons" }],
    },
    {
        title: "Faces",
        description: "0-10 rating faces and verbal pain scale illustrations.",
        icon: <Smile className="w-7 h-7 text-white" />,
        iconBg: "bg-gradient-to-br from-amber-500 to-amber-600",
        bgGradient: "bg-gradient-to-br from-amber-50 to-amber-50",
        hoverOverlay: "before:bg-gradient-to-br before:from-amber-100/50 before:to-amber-200/50",
        borderColor: "border-amber-200 hover:border-amber-300",
        primaryButtonClassName: "bg-amber-600 hover:bg-amber-700",
        links: [{ to: "/design/icons/faces", label: "Face icons" }],
    },
];

function DesignIconsHubPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Icons", route: { to: "/design/icons" } },
    ]);

    return (
        <AppHubPage title="Icons" description="Browse animated, state, and face icons from the shared icon package.">
            {iconGalleryItems.map((item) => (
                <AppHubCard key={item.title} {...item} />
            ))}
        </AppHubPage>
    );
}

export const Route = createFileRoute("/_app/design/icons/")({
    component: DesignIconsHubPage,
});
